"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _index = _interopRequireDefault(require("@insided/deprecated-control/dropdown-multiselection/index"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _utils = require("./../utils");

var _aiPanel = _interopRequireDefault(require("@insided/deprecated-control/ai-panel"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

var _Feedback = _interopRequireDefault(require("@insided/shared/modules/HubAI/Feedback/Feedback"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ADDITIONAL_INPUT_MAX_LENGTH = 500;
var GENERATING_ERROR_MESSAGE = 'Unable to generate a prompt. Please try to change the variables and try again.';
var DEFAULT_STATE = {
  type: null,
  goals: [],
  tone: '',
  length: null,
  additional: '',
  additionalInputTouched: false,
  isGenerating: false,
  generatedContent: '',
  isGeneratingError: false,
  lastGPTInput: ''
};

var GenerateEmail = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GenerateEmail, _Component);

  var _super = _createSuper(GenerateEmail);

  function GenerateEmail() {
    var _this;

    (0, _classCallCheck2.default)(this, GenerateEmail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _objectSpread(_objectSpread({}, DEFAULT_STATE), {}, {
      additionalInputTouched: false
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeGoals", function (goals) {
      _this.setState({
        goals: goals
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isAdditionalInputValid", function () {
      return _this.state.additional.length <= ADDITIONAL_INPUT_MAX_LENGTH;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancel", function () {
      _this.props.onClosePanel();

      setTimeout(function () {
        _this.setState(_objectSpread({}, DEFAULT_STATE));
      }, 400);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onStepBack", function () {
      _this.setState({
        isGenerating: false,
        generatedContent: '',
        isGeneratingError: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGenerate", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, type, goals, tone, length, additional, fieldsData, response;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, type = _this$state.type, goals = _this$state.goals, tone = _this$state.tone, length = _this$state.length, additional = _this$state.additional;
              fieldsData = {
                type: type ? type.prompt : '',
                goals: goals.map(function (goal) {
                  return goal.prompt;
                }).join(),
                tone: tone,
                length: length === null || length === void 0 ? void 0 : length.prompt,
                additional: additional
              };

              _this.setState({
                isGenerating: true,
                generatedContent: '',
                isGeneratingError: false,
                lastGPTInput: JSON.stringify(fieldsData)
              });

              _context.prev = 3;
              _context.next = 6;
              return _axios.default.post('/emailCampaign/generate', fieldsData);

            case 6:
              response = _context.sent;

              _this.setState(function (currentState) {
                var _response$data;

                return currentState.isGenerating ? {
                  isGenerating: false,
                  generatedContent: response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.result.split('\n\n').map(function (paragraph) {
                    return "<p>".concat(paragraph, "</p>");
                  }).join('')
                } : _objectSpread({}, currentState);
              });

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);

              _this.setState(function (currentState) {
                return currentState.isGenerating ? {
                  isGenerating: false,
                  isGeneratingError: true
                } : _objectSpread({}, currentState);
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInsertContent", function () {
      _this.onCancel();

      _this.props.onInsert(_this.state.generatedContent);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "additionalOnKeyUp", function (e) {
      if ((0, _typeGuards.hasValueInEventTarget)(e)) {
        _this.setState({
          additional: e.target.value
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getGenerateButton", function () {
      var _this$state2 = _this.state,
          type = _this$state2.type,
          goals = _this$state2.goals,
          tone = _this$state2.tone,
          length = _this$state2.length;
      var isGenerateAvailable = !!type && !!goals.length && !!tone && !!length;
      return (0, _preact.h)(_Button.default, {
        key: "generate-email",
        variant: "brand",
        className: "button-control__ai-primary",
        startIcon: "aiStarsWhite",
        title: "Generate",
        size: "medium",
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this.onGenerate();

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })),
        disabled: !isGenerateAvailable,
        "data-track-type": "click",
        "data-element-name": "Generate button"
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cancelButton", (0, _preact.h)(_Button.default, {
      key: "cancel-generate",
      title: "Cancel",
      size: "medium",
      className: "qa-cancel-generate",
      onClick: _this.onCancel,
      "data-track-type": "click",
      "data-element-name": "Cancel button"
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "stepBackButton", (0, _preact.h)(_Button.default, {
      key: "cancel-generating",
      title: "Cancel",
      size: "medium",
      className: "qa-cancel-generating",
      onClick: _this.onStepBack,
      "data-track-type": "click",
      "data-element-name": "Cancel button"
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contentButtons", (0, _preact.h)("div", {
      className: "action-buttons"
    }, (0, _preact.h)(_Button.default, {
      key: "generate-another",
      variant: "brand",
      className: "button-control__ai-secondary",
      startIcon: "aiStarsLinearGradient",
      onClick: _this.onGenerate,
      title: "View another",
      size: "medium",
      "data-track-type": "click",
      "data-element-name": "View another button"
    }), (0, _preact.h)(_Button.default, {
      key: "generated-insert",
      variant: "brand",
      className: "button-control__ai-primary",
      title: "Insert",
      size: "medium",
      onClick: _this.onInsertContent,
      "data-track-type": "click",
      "data-element-name": "Insert button"
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getForm", function () {
      var _type$title, _length$title;

      var _this$state3 = _this.state,
          type = _this$state3.type,
          goals = _this$state3.goals,
          tone = _this$state3.tone,
          length = _this$state3.length,
          additional = _this$state3.additional,
          additionalInputTouched = _this$state3.additionalInputTouched;
      return (0, _preact.h)("div", {
        className: "generate-form"
      }, (0, _preact.h)("div", {
        className: "generate-form-row"
      }, (0, _preact.h)("div", {
        className: "generate-form-type"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Type *",
        customInput: (0, _preact.h)(_DropdownControl.default, {
          closeOnDropdownClick: true,
          align: "adjust",
          triggerClass: "generate-type-dropdown qa-email-generate-type",
          items: _utils.generateEmailTypes.map(function (type) {
            return {
              title: type.title,
              onClick: function onClick() {
                return _this.setState({
                  type: type
                });
              }
            };
          }),
          trigger: (0, _preact.h)(_Button.default, {
            className: type ? 'selected' : 'default',
            title: (_type$title = type === null || type === void 0 ? void 0 : type.title) !== null && _type$title !== void 0 ? _type$title : 'Select the email type',
            icon: "chevronDown",
            size: "medium",
            "data-track-type": "click",
            "data-element-name": "Select the email type button"
          })
        })
      })), (0, _preact.h)("div", {
        className: "generate-form-goals"
      }, (0, _preact.h)(_index.default, {
        id: "generate-goals",
        label: "Goal(s)",
        subtext: " *",
        placeholder: "Select one or more goals",
        items: _utils.generateEmailGoals,
        selectedItems: goals,
        onChange: _this.onChangeGoals
      }))), (0, _preact.h)("div", {
        className: "generate-form-row"
      }, (0, _preact.h)("div", {
        className: "generate-form-tone"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Tone *",
        customInput: (0, _preact.h)(_DropdownControl.default, {
          closeOnDropdownClick: true,
          align: "adjust",
          triggerClass: "generate-tone-dropdown qa-email-generate-tone",
          items: _utils.generateEmailTones.map(function (tone) {
            return _objectSpread(_objectSpread({}, tone), {}, {
              onClick: function onClick() {
                return _this.setState({
                  tone: tone.title
                });
              }
            });
          }),
          trigger: (0, _preact.h)(_Button.default, {
            className: tone ? 'selected' : 'default',
            title: tone || 'Select the email tone',
            icon: "chevronDown",
            size: "medium",
            "data-track-type": "click",
            "data-element-name": "Select the email tone button"
          })
        })
      })), (0, _preact.h)("div", {
        className: "generate-form-length"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Length *",
        customInput: (0, _preact.h)(_DropdownControl.default, {
          closeOnDropdownClick: true,
          align: "adjust",
          triggerClass: "generate-length-dropdown qa-email-generate-length",
          items: _utils.generateEmailLength.map(function (length) {
            return {
              title: length.title,
              onClick: function onClick() {
                return _this.setState({
                  length: length
                });
              }
            };
          }),
          trigger: (0, _preact.h)(_Button.default, {
            className: length ? 'selected' : 'default',
            title: (_length$title = length === null || length === void 0 ? void 0 : length.title) !== null && _length$title !== void 0 ? _length$title : 'Select the email length',
            icon: "chevronDown",
            size: "medium",
            "data-track-type": "click",
            "data-element-name": "Select the email length"
          })
        })
      }))), (0, _preact.h)("div", {
        className: "generate-form-row"
      }, (0, _preact.h)("div", {
        className: "generate-form-additional"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Additional inputs",
        placeholder: "Enter additional inputs",
        value: additional,
        max: 500,
        showCharactersLeft: true,
        hasError: additionalInputTouched && !_this.isAdditionalInputValid(),
        error: additionalInputTouched && !_this.isAdditionalInputValid() ? 'Maximum length: 500 characters. Please reduce the length of your additional inputs' : '',
        onBlur: function onBlur() {
          _this.setState({
            additionalInputTouched: true
          });
        },
        onKeyUp: _this.additionalOnKeyUp
      }))));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getGeneratedContent", function () {
      var _this$state4 = _this.state,
          generatedContent = _this$state4.generatedContent,
          lastGPTInput = _this$state4.lastGPTInput;
      return (0, _preact.h)("div", {
        className: "generated-content"
      }, (0, _preact.h)("div", {
        className: "generated-content-main",
        dangerouslySetInnerHTML: {
          __html: generatedContent
        }
      }), (0, _preact.h)("div", {
        className: "create-email-campaign__feedback"
      }, (0, _preact.h)(_Feedback.default, {
        featureName: "email-campaign",
        options: ['Inaccurate content', 'Tone issues', 'Too generic', 'Formatting issues', 'Irrelevant suggestions'],
        input: lastGPTInput,
        output: generatedContent
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "errorMessage", (0, _preact.h)("div", {
      className: "generated-content"
    }, (0, _preact.h)("div", {
      className: "generated-content-main"
    }, GENERATING_ERROR_MESSAGE)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "generatingSkeleton", (0, _preact.h)("div", {
      className: "generating-skeleton"
    }, (0, _preact.h)("div", {
      className: "generating-skeleton__item full-width"
    }), (0, _preact.h)("div", {
      className: "generating-skeleton__item full-width"
    }), (0, _preact.h)("div", {
      className: "generating-skeleton__item half-width"
    })));
    return _this;
  }

  (0, _createClass2.default)(GenerateEmail, [{
    key: "render",
    value: function render() {
      var isOpen = this.props.isOpen;
      var _this$state5 = this.state,
          isGenerating = _this$state5.isGenerating,
          generatedContent = _this$state5.generatedContent,
          isGeneratingError = _this$state5.isGeneratingError;
      var showForm = !isGenerating && !generatedContent && !isGeneratingError;
      var showLoading = isGenerating && !generatedContent;
      var showError = !isGenerating && !generatedContent && isGeneratingError;
      var showContent = !isGenerating && generatedContent && !isGeneratingError;
      var content = showForm ? this.getForm() : null;
      var leftButtons = showForm ? this.cancelButton : this.stepBackButton;
      var rightButtons = showForm ? this.getGenerateButton() : null;

      if (showLoading) {
        content = this.generatingSkeleton;
      }

      if (showError) {
        content = this.errorMessage;
      }

      if (showContent) {
        rightButtons = this.contentButtons;
        content = this.getGeneratedContent();
      }

      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('create-email-campaign__generate', {
          'is-open': isOpen
        }),
        "data-bounded-context": "HubAI",
        "data-entity": "Generate email"
      }, (0, _preact.h)(_aiPanel.default, {
        title: "Write with AI",
        className: "ai-panel-generate-email",
        isGenerating: showLoading,
        contentName: "email",
        leftActions: leftButtons,
        rightActions: rightButtons
      }, content));
    }
  }]);
  return GenerateEmail;
}(_preact.Component);

var _default = GenerateEmail;
exports.default = _default;